<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption"
                       :data="tableData"
                       :table-loading="tableLoading"
                       :page="page"
                       ref="crud"
                       @search-change="searchChange"
                       @refresh-change="refreshChange"
                       @row-save="handleSave"
                       @row-update="handleUpdate"
                       @selection-change="handleSelectionChange"
                       @size-change="pageSizeChange"
                       @current-change="pageChange">
                <template slot-scope="scope" slot="menu">
                    <el-button type="success"
                               icon="el-icon-view"
                               size="small"
                               plain
                               @click.stop="detail(scope.row.id)"
                    >查看</el-button>
                </template>
            </avue-crud>
            <el-dialog title="客户账户余额入账详情" :visible.sync="details">
                <el-form :model="detailsData">
                    <el-form-item label="客户店铺:">
                        <el-input v-model="detailsData.shopName" style="width: 500px" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="客户姓名:">
                        <el-input v-model="detailsData.name" style="width: 500px" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="地区:">
                        <el-input v-model="detailsData.area" style="width: 500px" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号:">
                        <el-input v-model="detailsData.mobile" style="width: 500px" :disabled="true"></el-input>
                    </el-form-item>
                    <el-form-item label="客户入账金额:">
                        <el-input v-model="detailsData.amount" style="width: 500px" :disabled="true"></el-input>
                    </el-form-item>
                    <!--<el-form-item label="客户账户总金额:">-->
                        <!--<el-input v-model="detailsData.totalAmount" style="width: 500px" :disabled="true"></el-input>-->
                    <!--</el-form-item>-->
                    <div>客户入账凭证:</div>
                    <viewer :images="detailsData.vouchers"   >
                        <img v-for="src in detailsData.vouchers" :src="src" :key="src" width="50">
                    </viewer>
                    <!--<img :src="item" style="width: 200px;-->
                <!--height: 200px;margin-left: 20px;margin-top: 20px" v-for="(item,index) in src">-->
                </el-form>
                <!--<div slot="footer" class="dialog-footer">-->
                    <!--<el-button type="success" @click="getPdf()" style="display: none">导出PDF</el-button>-->
                <!--</div>-->
            </el-dialog>
        </basic-container>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {balanceDetailsOption} from "@/const/salesCloud/balanceDetailsOption";
    import {details,detail} from "@/api/salesCloud/balanceDetails"
    import {calculatedBalance} from "@/api/salesCloud/checkDetail"
    import {findByLabel, formatterTime} from "@/util/util"
    import {DIC} from "@/const/dic"

    export default {
        name: "balanceDetails",
        data() {
            return {
                tableOption: balanceDetailsOption, //表格设置属性
                tableData: [], //表格的数据
                tablePage: 1,
                tableLoading: false,
                tabelObj: {},
                page: {
                    total: 0, //总页数
                    currentPage: 1, //当前页数
                    pageSize: 10 //每页显示多少条
                },
                grade: {
                    box: false,
                    check: []
                },
                id:this.$route.query.id,
                details:false,
                detailsData:{}
            };
        },
        created() {
            this.handleList();
        },
        watch: {},
        mounted() {
        },
        computed: {
            ...mapGetters(["permission"])
        },
        props: [],
        methods: {
            pageSizeChange(pageSize) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = this.page.currentPage,
                    params.size = pageSize
                details(this.id).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: this.page.currentPage,
                        pageSize: pageSize
                    };
                    this.tableLoading = false;
                })
            },
            pageChange(page) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = page
                params.size = this.page.pageSize
                details(this.id).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: page,
                        pageSize: this.page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            searchChange(params) {
                this.tableLoading = true;
                // let params = this.$refs.crud.searchForm
                params.page = this.page.currentPage
                params.size = this.page.pageSize
                details(this.id).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: params.page,
                        pageSize: params.size
                    };
                    this.tableLoading = false;
                })
            },
            refreshChange(page) {
                this.tableLoading = true;
                let params = this.$refs.crud.searchForm
                params.page = page.currentPage
                params.size = page.pageSize
                details(this.id).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: page.currentPage,
                        pageSize: page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            /**
             * @title 打开新增窗口
             * @detail 调用crud的handleadd方法即可
             *
             **/
            handleAdd() {
                this.selectWeek=[]
                this.$refs.crud.rowAdd();
            },
            handleEdit(row, index) {
                this.selectWeek=this.formatWeek(row.week)
                this.$refs.crud.rowEdit(row, index);
            },
            /**
             * @title 获取数据
             * @detail 赋值为tableData表格即可
             *
             **/
            handleList() {
                this.tableLoading = true;
                let parmas = {
                    page: this.page.currentPage,
                    size: this.page.pageSize
                }
                details(this.id).then((res) => {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: this.page.currentPage,
                        pageSize: this.page.pageSize
                    };
                    this.tableLoading = false;
                })
            },
            /**
             * @title 数据添加
             * @param row 为当前的数据
             * @param done 为表单关闭函数
             *
             **/
            handleSave(row, done) {
                //
                // console.log("row："+JSON.stringify(row))
                // addWalletBalance(row).then(response => {
                //     if (response.code == '200') {
                //         this.$message({
                //             showClose: true,
                //             message: "添加成功",
                //             type: "success"
                //         });
                //         this.handleList();
                //     } else {
                //         this.$message({
                //             showClose: true,
                //             message: response.message,
                //             type: "error"
                //         })
                //     }
                //
                // }).catch(error => {
                //     this.loading = false
                //     this.$message({
                //         showClose: true,
                //         message: error,
                //         type: "error"
                //     })
                // })
                // done();
            },
            /**
             * @title 当前选中的数据
             * @param val 选中的值
             *
             **/
            handleSelectionChange() {
                // console.log(val);
                // this.tableRow = val;
                // this.$notify({
                //     showClose: true,
                //     message: JSON.stringify(val),
                //     type: 'success',
                // });
            },
            /**
             * @title 数据删除
             * @param row 为当前的数据
             * @param index 为当前更新数据的行数
             *
             **/
            handleDel(dicName, label) {
                // if(this.$refs.crud.tableSelect.length == 0){
                //     this.$message({
                //         showClose: true,
                //         message: "请选择要操作的数据",
                //         type: "error"
                //     })
                //     return
                // }
                //
                // this.$confirm(`是否确认删除?`, "提示", {
                //     confirmButtonText: "确定",
                //     cancelButtonText: "取消",
                //     type: "warning"
                // })
                //     .then(() => {
                //         let ids = new Array();
                //         for(let row of this.$refs.crud.tableSelect){
                //             ids.push(row.id)
                //         }
                //         delWalletBalance( ids).then(response => {
                //             if(response.code == '200'){
                //                 this.$message({
                //                     showClose: true,
                //                     message: "删除成功",
                //                     type: "success"
                //                 });
                //                 this.handleList();
                //             }else{
                //                 this.$message({
                //                     showClose: true,
                //                     message: response.message,
                //                     type: "error"
                //                 })
                //             }
                //
                //         }).catch(error => {
                //             this.loading = false
                //             this.$message({
                //                 showClose: true,
                //                 message: error,
                //                 type: "error"
                //             })
                //         })
                //     })
                //     .catch(() => { });
            },
            /**
             * @title 数据更新
             * @param row 为当前的数据
             * @param index 为当前更新数据的行数
             * @param done 为表单关闭函数
             *
             **/
            handleUpdate(row, index, done) {
                // let week=""
                // for(let i=0;i<this.selectWeek.length;i++){
                //     week+=this.selectWeek[i].value+","
                // }
                // week=week.substring(0,week.length-1)
                // row.week=week;
                // console.log("row："+JSON.stringify(row))
                // updateWalletDepositLimit(row).then(response => {
                //     if (response.code == '200') {
                //         this.$message({
                //             showClose: true,
                //             message: "修改成功",
                //             type: "success"
                //         });
                //         this.handleList();
                //     } else {
                //         this.$message({
                //             showClose: true,
                //             message: response.message,
                //             type: "error"
                //         })
                //     }
                //
                // }).catch(error => {
                //     this.loading = false
                //     this.$message({
                //         showClose: true,
                //         message: error,
                //         type: "error"
                //     })
                // })
                // done();
            },
            detail(id){
                this.details=true
                detail(id).then((res) => {
                    let data = JSON.parse(res.data);
                    calculatedBalance(data.id).then((res) => {
                        this.detailsData=data
                        this.detailsData.area=this.detailsData.province+this.detailsData.city+this.detailsData.area
                        this.detailsData.totalAmount=res.data
                        //console.log("row："+ JSON.stringify(JSON.parse(res.data)))
                    })

                    console.log("数据："+JSON.stringify(res))

                })
            },
            formmaterImage(row){
                let str = new Array();
                console.log("row："+ JSON.stringify(row))
                if(row!=null){
                    let picArray=row.split(",")
                    for(let i = 0;i < picArray.length;i++){
                        // console.log("url："+ row[i].url)
                        str.push(picArray[i])
                    }
                }
                return str
            }


        }

    };
</script>

<style lang="scss">
    .table-container {
        padding: 8px 10px;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>
